import { Row } from '@christiankaindl/lyts'
import { BookMarked as LawIcon } from 'lucide-react'
import Text from '@shared/components/Text/Text'
import { theme } from '@shared/styles/theme.css'
import { ScaleIcon } from 'lucide-react'

interface Props {
  text: string
  size?: 'small' | 'default'
  iconType?: 'law' | 'decision'
}

const icons = {
  law: LawIcon,
  decision: ScaleIcon,
}

export default function LabelWithIcon({ size, text, iconType = 'law' }: Props) {
  const Icon = icons[iconType]
  return (
    <Row
      tabIndex={0}
      gap={0.25}
      style={{ color: theme.colors.text.brand, cursor: 'default' }}
    >
      <Icon
        size={size === 'small' ? 16 : 20}
        width={size === 'small' ? 16 : 20}
      />
      <Text
        size={size}
        color={theme.colors.text.brand}
        weight={600}
        maxLines={1}
      >
        {text}
      </Text>
    </Row>
  )
}
